/**
 * "Load more" for collection priority rules (see "Priority rules" in sections/main-collection.liquid). Page 1 renders
 * the priority products plus the first page of the others; each click fetches the next page of the same filtered URL
 * through the Section Rendering API and appends its cards. A page whose products were all shown already comes back
 * empty, so it is skipped until cards are found or the pages run out.
 */
if (!window.customElements.get('collection-load-more')) {
  class CollectionLoadMore extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.button?.addEventListener('click', this.loadNext.bind(this));
    }

    async loadNext() {
      const list = document.getElementById(this.getAttribute('target'));
      const totalPages = parseInt(this.getAttribute('total-pages'), 10) || 1;
      let page = parseInt(this.getAttribute('next-page'), 10) || 2;

      if (!list || this.button.disabled) return;

      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      try {
        let cards = [];

        while (cards.length === 0 && page <= totalPages) {
          const url = new URL(window.location.href);
          url.searchParams.set('page', page);
          url.searchParams.set('section_id', this.getAttribute('section-id'));

          const response = await fetch(url.toString());
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          cards = Array.from(html.querySelectorAll(`#${CSS.escape(list.id)} > product-card`));
          page++;
        }

        const imported = cards.map((card) => {
          // The list's reveal animation already ran, so appended cards must not wait for it
          card.removeAttribute('reveal-on-scroll');
          return list.appendChild(document.importNode(card, true));
        });
        imported[0]?.querySelector('a[href]')?.focus({ preventScroll: true });

        this.setAttribute('next-page', page);

        if (page > totalPages) {
          this.remove();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      }
    }
  }

  window.customElements.define('collection-load-more', CollectionLoadMore);
}
